module.exports = __webpack_public_path__ + "static/img/Ahmedabad.001a688.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/city/Ahmedabad.png
// module id = 2SbB
// module chunks = 12